import { useNuxtApp } from '#app/nuxt';
import { formatError as baseFormatError } from '#layers/base/public';

export function useErrorFormatter() {
	const { $i18n: i18n } = useNuxtApp();

	const formatError = (error: any): string => {
		return baseFormatError(error, i18n);
	};

	return {
		formatError,
	};
}
